import { useFeatureToggle } from "./useFeatureToggle";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export const FeatureToggle = _ref => {
  let {
    children,
    name,
    off = null,
    on = null
  } = _ref;
  const {
    enabled,
    isLoading
  } = useFeatureToggle(name);
  return isLoading ? null : /*#__PURE__*/_jsx(_Fragment, {
    children: enabled ? on ?? children : off
  });
};